import React, { useContext } from 'react'
import classNames from 'classnames'
import SubMenuItem from './SubMenuItem'
import { I18nextContext } from '@toasttab/shared/src/context/i18nextContext'
import { localizeLink } from '@toasttab/shared/src/utils/linkUtils'
import { EntryTypes, SubMenuEntryProps } from './ContentfulNavigation.d'

const SubMenuEntry = ({
  columnLink,
  hideEntryTitle,
  menuType = 'desktop',
  mobileTitle,
  sectionListClasses,
  subMenuEntries,
  subMenuEntryType,
  title
}: SubMenuEntryProps) => {
  const localizationContext = useContext(I18nextContext)
  const entryType: EntryTypes = subMenuEntryType

  const sectionHeadingCss = classNames(
    'font-effra font-normal text-base lg:text-[15px] leading-none',
    {
      'text-default mb-1 lg:mb-3 group-hover:text-blue-75 group-focus:text-blue-75 group-hover:font-semibold group-focus:font-semibold':
        entryType === 'articles',
      'text-secondary mb-6 lg:mb-3': entryType !== 'articles'
    }
  )

  const entryTitle = menuType === 'mobile' && mobileTitle ? mobileTitle : title
  let sortedSubMenuEntries = subMenuEntries
  if (menuType === 'mobile' && subMenuEntries?.some((sub) => sub.mobileOrder)) {
    sortedSubMenuEntries = [...subMenuEntries].sort(
      (a, b) => a.mobileOrder - b.mobileOrder
    )
  }

  const sectionListCss = classNames(
    'flex flex-col flex-nowrap',
    sectionListClasses
  )

  if (entryType === 'articles') {
    const articleHref = localizeLink(
      sortedSubMenuEntries[0]?.url,
      localizationContext.language,
      localizationContext
    )
    return (
      <a
        className={`${sortedSubMenuEntries[0]?.heapClass} block mb-8 lg:h-[116px] lg:mb-4 group`}
        data-testid='SubMenuEntry-article'
        href={articleHref}
        key={`${menuType}-sub-menu-section-${title}}`}
        role='menuitem'
      >
        {entryTitle && !hideEntryTitle ? (
          <h5 className={sectionHeadingCss}>
            {entryTitle}
            <span className='inline-flex invisible relative left-[0.625rem] top-2 content-icon-right-arrow-blue h-6 w-6 group-hover:visible group-focus:visible' />
          </h5>
        ) : null}
        <ul className={sectionListCss}>
          {sortedSubMenuEntries?.map((entry) => (
            <SubMenuItem
              entryType={entryType}
              key={`${menuType}-${title}-${entry.title}`}
              {...entry}
            />
          ))}
        </ul>
      </a>
    )
  } else {
    return (
      <div
        className='[&:not(:last-child)]:mb-2 lg:[&:not(:last-child)]:mb-8'
        data-testid='SubMenuEntry'
        key={`${menuType}-sub-menu-section-${title}}`}
      >
        {entryTitle && !hideEntryTitle ? (
          <h5 className={sectionHeadingCss}>
            <span className='py-2 border-b border-gray-25 inline-block leading-none'>
              {entryTitle}
            </span>
          </h5>
        ) : null}
        <ul className={sectionListCss}>
          {sortedSubMenuEntries?.map((entry) => (
            <SubMenuItem
              entryType={entryType}
              key={`${menuType}-${entry.title}`}
              {...entry}
            />
          ))}
          {columnLink ? (
            <a
              className='block text-[15px] -mt-2 mb-8 lg:mt-2 lg:mb-0 text-default font-normal flex items-center group hover:text-blue-75 focus:text-blue-75 hover:font-semibold focus:font-semibold'
              href={columnLink.url}
            >
              <span className='before:content-icon-all-products before:block before:leading-none pt-0.5 bg-neutral rounded-full flex items-center justify-center w-8 h-8 mr-2' />
              {columnLink.title}
              <span className='inline-flex invisible -mt-1 ml-1 content-icon-right-arrow-blue h-6 w-6 group-hover:visible group-focus:visible' />
            </a>
          ) : null}
        </ul>
      </div>
    )
  }
}

export default SubMenuEntry
